import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const trainingPages = [
  {
    id: 'makecode-arcade',
    title: 'MakeCode Arcade 연수',
    description: '게임 개발을 통한 프로그래밍 교육',
    status: 'completed',
    duration: '4시간',
    date: '2024-01-15',
    instructor: '김교사',
    path: '/teacher-training/training/completed/MakeCodeArcadeTraining',
    category: '프로그래밍',
    tags: ['MakeCode', '게임개발', '기초'],
  },
  {
    id: '3d-modeling',
    title: '3D 모델링 연수',
    description: '3D 프린팅과 모델링 기초',
    status: 'upcoming',
    duration: '3시간',
    date: '2024-02-10',
    instructor: '박교사',
    path: '/teacher-training/training/upcoming/ThreeDModelingTraining',
    category: '3D모델링',
    tags: ['3D프린팅', '모델링', '디자인'],
  },
  {
    id: 'deagwang-ai-edutech',
    title: '대광고등학교 AI 에듀테크 연수',
    description: '교육현장에서 AI 에듀테크를 활용한 수업 설계 및 실습',
    status: 'active',
    duration: '2시간',
    date: '2025-10-01',
    instructor: '한지호',
    path: '/teacher-training/digital/DeaGwamgAIEdutechTraining',
    category: 'AI',
    tags: ['AI', '에듀테크', '수업설계', '교육혁신'],
  },
  {
    id: 'elementary-3d-printing-2026',
    title: '2026 「(초등) 3D프린팅 활용 직무연수」',
    description: '3D프린팅·Sculpt 모델링·굿즈 제작 (서울융합과학원)',
    status: 'upcoming',
    duration: '3시간',
    date: '2026-04-09',
    instructor: '담당 강사',
    path: '/teacher-training/digital/Elementary3DPrintingTraining2026',
    category: '3D프린팅',
    tags: ['3D프린팅', 'Sculpt', '직무연수', '초등'],
  },
  {
    id: 'middle-school-3d-printing-2026',
    title: '2026 「(중등) 3D프린팅 활용 직무연수」',
    description: '3D프린팅·Sculpt 모델링·굿즈 제작 (서울융합과학원)',
    status: 'upcoming',
    duration: '3시간',
    date: '2026-04-09',
    instructor: '담당 강사',
    path: '/teacher-training/digital/MiddleSchool3DPrintingTraining2026',
    category: '3D프린팅',
    tags: ['3D프린팅', 'Sculpt', '직무연수', '중등'],
  },
  {
    id: 'central-middle-debeth-ai-digital-leader-2026',
    title: '중부 AI에듀테크 담당자 연수',
    description: '2026 중부 중등 디벗 핵심교원 AI·디지털 리더 연수 — 아이패드·MDM·수업 사례 (상연재 서울시청점)',
    status: 'upcoming',
    duration: '3시간',
    date: '2026-04-22',
    instructor: '담당 강사',
    path: '/teacher-training/digital/CentralMiddleDebethAIDigitalLeaderTraining2026',
    category: 'AI·디벗',
    tags: ['중부', '디벗', '아이패드', 'MDM', 'AI'],
  },
  {
    id: 'namdaemoon-middle-debeth-2026',
    title: '남대문중학교 디벗 연수',
    description: 'AI·디지털 동향, 학습지원 SW 심의, SEN 스쿨·Canva·Seam 스페이스·전자칠판 활용',
    status: 'active',
    duration: '2시간',
    date: '2026-06-11',
    instructor: '한지호',
    path: '/teacher-training/digital/NamdaemoonMiddleSchoolDebethTraining2026',
    category: 'AI·디벗',
    tags: ['남대문중', '디벗', 'AI', 'SEN스쿨', 'Canva', 'Seam스페이스'],
  },
  {
    id: 'namdaemoon-middle-debeth-2026-session2',
    title: '남대문중학교 디벗 연수 2회차',
    description: 'ZEP School·ZEP Quiz·QuizN·Google Vids·Gemini·NotebookLM 참여형 수업',
    status: 'active',
    duration: '2시간',
    date: '2026-06-19',
    instructor: '한지호',
    path: '/teacher-training/digital/NamdaemoonMiddleSchoolDebethTraining2026Session2',
    category: 'AI·디벗',
    tags: ['남대문중', '디벗', 'ZEP', 'QuizN', 'Google Vids', 'NotebookLM'],
  },
  {
    id: 'ewha-geumran-middle-ai-2026',
    title: '이화금란중학교 AI 업무 간소화 연수',
    description: 'Gemini·GPT 기반 가정통신문·안내문 작성, 이수증 정리, 업무 자동화 설계',
    status: 'upcoming',
    duration: '100분',
    date: '2026-06-15',
    instructor: '한지호',
    path: '/teacher-training/digital/EwhaGeumranMiddleSchoolAITraining2026',
    category: 'AI',
    tags: ['이화금란중', 'Gemini', 'GPT', '가정통신문', '업무경감'],
  },
  {
    id: 'jingwan-middle-ai-2026',
    title: '진관중학교 AI 기반 수업 준비 및 자료 작성 연수',
    description: 'ChatGPT·Gemini·Claude·Copilot·Perplexity 비교, HWPX 실습, PPT 제작 흐름, 바이브코딩',
    status: 'upcoming',
    duration: '100분',
    date: '2026-06-24',
    instructor: '한지호',
    path: '/teacher-training/digital/JingwanMiddleSchoolAITraining2026',
    category: 'AI',
    tags: ['진관중', 'ChatGPT', 'Gemini', 'Claude', 'Copilot', '수업자료'],
  },
];

const referenceMaterials = [
  {
    id: 'makecode-basics',
    title: 'MakeCode Arcade란?',
    category: 'makecode',
    type: 'article',
    description: 'MakeCode Arcade의 기본 개념과 특징에 대해 알아봅니다.',
    tags: ['기초', '개념', '소개'],
  },
  {
    id: 'makecode-install',
    title: 'MakeCode Arcade IDE 설치하기',
    category: 'makecode',
    type: 'guide',
    description: 'MakeCode Arcade IDE 설치 및 설정 방법을 단계별로 안내합니다.',
    tags: ['설치', '설정', '환경구축'],
  },
  {
    id: 'makecode-first-game',
    title: '첫 번째 게임 만들기',
    category: 'makecode',
    type: 'tutorial',
    description: '간단한 게임을 만들어보며 MakeCode의 기본 기능을 익힙니다.',
    tags: ['게임개발', '기초', '실습'],
  },
  {
    id: '3d-modeling-basics',
    title: '3D 모델링 기초',
    category: '3d-modeling',
    type: 'article',
    description: '3D 모델링의 기본 개념과 도구에 대해 알아봅니다.',
    tags: ['3D모델링', '기초', '개념'],
  },
  {
    id: 'tinkercad-guide',
    title: 'Tinkercad 사용법',
    category: '3d-modeling',
    type: 'guide',
    description: 'Tinkercad를 이용한 3D 모델링 방법을 단계별로 안내합니다.',
    tags: ['Tinkercad', '3D모델링', '웹도구'],
  },
];

const materialCategories = [
  { id: 'all', name: '전체', icon: '📚' },
  { id: 'makecode', name: 'MakeCode Arcade', icon: '🎮' },
  { id: '3d-modeling', name: '3D 모델링', icon: '🎨' },
];

const TrainingPages: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'upcoming':
        return 'warning';
      case 'active':
        return 'primary';
      default:
        return 'default';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'completed':
        return '완료';
      case 'upcoming':
        return '예정';
      case 'active':
        return '진행중';
      default:
        return status;
    }
  };

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'article':
        return '📄';
      case 'tutorial':
        return '🎥';
      case 'guide':
        return '💻';
      default:
        return '📄';
    }
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'article':
        return '#1976d2';
      case 'tutorial':
        return '#9c27b0';
      case 'guide':
        return '#2e7d32';
      default:
        return '#666';
    }
  };

  const getTypeText = (type: string) => {
    switch (type) {
      case 'article':
        return '개념 설명';
      case 'tutorial':
        return '실습 튜토리얼';
      case 'guide':
        return '설치/설정 가이드';
      default:
        return type;
    }
  };

  const groupedMaterials = useMemo(() => {
    const filtered = referenceMaterials.filter((material) => {
      const matchesSearch =
        material.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        material.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        material.tags.some((tag) => tag.toLowerCase().includes(searchTerm.toLowerCase()));
      const matchesCategory = selectedCategory === 'all' || material.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });

    return filtered.reduce(
      (acc, material) => {
        if (!acc[material.category]) acc[material.category] = [];
        acc[material.category].push(material);
        return acc;
      },
      {} as Record<string, typeof referenceMaterials>
    );
  }, [searchTerm, selectedCategory]);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '24px 32px',
          flex: '0 0 auto',
        }}
      >
        <h1 style={{ fontSize: '2.5rem', fontWeight: '700', margin: '0 0 12px 0' }}>연수</h1>
        <p style={{ fontSize: '1.125rem', opacity: 0.9, margin: 0, lineHeight: 1.6 }}>
          진행용 연수 페이지와 참고 자료를 한곳에서 확인합니다.
        </p>
      </div>

      <div style={{ flex: '1 1 auto', overflow: 'auto', padding: '24px 32px' }}>
        <h2 style={{ fontSize: '1.35rem', fontWeight: 700, margin: '0 0 16px', color: 'var(--Color-text-strong, #0D0D0D)' }}>
          연수 진행 페이지
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px',
            marginBottom: '40px',
          }}
        >
          {trainingPages.map((page) => (
            <div
              key={page.id}
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                overflow: 'hidden',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              }}
            >
              <div style={{ padding: '24px', flexGrow: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                  <h3 style={{ fontWeight: 'bold', flex: 1, margin: '0 16px 0 0', fontSize: '1.25rem' }}>{page.title}</h3>
                  <span
                    style={{
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '0.75rem',
                      fontWeight: '500',
                      backgroundColor:
                        getStatusColor(page.status) === 'success'
                          ? '#e8f5e8'
                          : getStatusColor(page.status) === 'warning'
                            ? '#fff3cd'
                            : '#e3f2fd',
                      color:
                        getStatusColor(page.status) === 'success'
                          ? '#2e7d32'
                          : getStatusColor(page.status) === 'warning'
                            ? '#f57c00'
                            : '#1976d2',
                    }}
                  >
                    {getStatusText(page.status)}
                  </span>
                </div>
                <p style={{ color: '#666', marginBottom: '16px', fontSize: '0.875rem' }}>{page.description}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
                  <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '0.75rem', border: '1px solid #ddd', backgroundColor: '#f5f5f5' }}>
                    {page.category}
                  </span>
                  {page.tags.map((tag) => (
                    <span
                      key={tag}
                      style={{
                        padding: '4px 8px',
                        borderRadius: '12px',
                        fontSize: '0.75rem',
                        border: '1px solid #1976d2',
                        color: '#1976d2',
                        backgroundColor: '#e3f2fd',
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <p style={{ color: '#666', fontSize: '0.875rem', margin: 0 }}>📅 {page.date}</p>
              </div>
              <div style={{ padding: '0 24px 24px 24px' }}>
                <button
                  type="button"
                  onClick={() => navigate(page.path)}
                  style={{
                    width: '100%',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    fontWeight: '500',
                    background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                  }}
                >
                  연수 열기 →
                </button>
              </div>
            </div>
          ))}
        </div>

        <h2 style={{ fontSize: '1.35rem', fontWeight: 700, margin: '0 0 16px', color: 'var(--Color-text-strong, #0D0D0D)' }}>
          참고 자료
        </h2>
        <div
          style={{
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <input
            type="text"
            placeholder="자료 검색..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: '1 1 240px',
              padding: '12px 16px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '1rem',
            }}
          />
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{
              minWidth: '200px',
              padding: '12px 16px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '1rem',
              backgroundColor: 'white',
            }}
          >
            {materialCategories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.icon} {category.name}
              </option>
            ))}
          </select>
        </div>

        {Object.keys(groupedMaterials).length === 0 ? (
          <p style={{ color: '#666', margin: 0 }}>해당하는 참고 자료가 없습니다.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {Object.entries(groupedMaterials).map(([category, categoryMaterials]) => {
              const categoryInfo = materialCategories.find((cat) => cat.id === category);
              return (
                <details
                  key={category}
                  open
                  style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflow: 'hidden' }}
                >
                  <summary
                    style={{
                      padding: '16px 24px',
                      backgroundColor: '#f8f9fa',
                      borderBottom: '1px solid #e9ecef',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '1.125rem',
                    }}
                  >
                    {categoryInfo?.icon} {categoryInfo?.name} ({categoryMaterials.length})
                  </summary>
                  <div>
                    {categoryMaterials.map((material, index) => (
                      <div
                        key={material.id}
                        id={material.id}
                        style={{
                          padding: '16px 24px',
                          borderBottom: index < categoryMaterials.length - 1 ? '1px solid #e9ecef' : 'none',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                        }}
                      >
                        <div style={{ fontSize: '1.5rem' }}>{getTypeIcon(material.type)}</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', flexWrap: 'wrap' }}>
                            <h4 style={{ fontWeight: 'bold', margin: 0, fontSize: '1.125rem' }}>{material.title}</h4>
                            <span
                              style={{
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                border: `1px solid ${getTypeColor(material.type)}`,
                                color: getTypeColor(material.type),
                              }}
                            >
                              {getTypeText(material.type)}
                            </span>
                          </div>
                          <p style={{ color: '#666', margin: 0, fontSize: '0.875rem' }}>{material.description}</p>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            navigator.clipboard.writeText(`${window.location.origin}/teacher-training/training-pages#${material.id}`);
                            window.alert('링크가 클립보드에 복사되었습니다.');
                          }}
                          style={{
                            padding: '8px 16px',
                            backgroundColor: 'transparent',
                            border: '1px solid #1976d2',
                            borderRadius: '4px',
                            color: '#1976d2',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                          }}
                        >
                          링크 복사
                        </button>
                      </div>
                    ))}
                  </div>
                </details>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default TrainingPages;
